const LEGACY_TOKEN_KEYS = ['rna_auth_access_token', 'rna_auth_refresh_token'];

let accessToken = null;
let sessionGeneration = 0;
let refreshAllowed = true; // A fresh page may recover its HttpOnly-cookie session.

function removeLegacyPersistedTokens() {
  if (typeof window === 'undefined') {
    return;
  }

  LEGACY_TOKEN_KEYS.forEach((key) => {
    window.localStorage.removeItem(key);
    window.sessionStorage.removeItem(key);
  });
}

removeLegacyPersistedTokens();

export const tokenService = {
  getAccessToken() {
    return accessToken;
  },

  getSessionGeneration() {
    return sessionGeneration;
  },

  canRefresh() {
    return refreshAllowed;
  },

  beginSession() {
    sessionGeneration += 1;
    accessToken = null;
    refreshAllowed = true;
    removeLegacyPersistedTokens();
    return sessionGeneration;
  },

  setAccessToken(access, generation = sessionGeneration) {
    if (generation !== sessionGeneration || !refreshAllowed) return false;
    accessToken = access || null;
    return true;
  },

  clearAccessToken() {
    sessionGeneration += 1;
    refreshAllowed = false;
    accessToken = null;
    removeLegacyPersistedTokens();
  },
};
